import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import get from 'lodash.get';

import { AppState } from 'services/types';
import { ProductId } from 'services/products/types';
import { FertilizerProductPerUnitType } from 'services/fertilizerEvents/types';
import { HECTARE } from 'services/perUnitTypes/types';
import { OwnProps } from './index';
import {
    selectFertilizerWorksheetProductsKeyedById,
    selectFertilizerWorksheetEntitySummaries
} from '../../../../selectors';

const selectProductId = (state: AppState, props: OwnProps): ProductId =>
    props.productId;

const selectPerUnitType = (
    state: AppState,
    props: OwnProps
): FertilizerProductPerUnitType => props.perUnitType;

const selectProductTotal = createDeepEqualSelector(
    selectFertilizerWorksheetProductsKeyedById,
    selectFertilizerWorksheetEntitySummaries,
    selectProductId,
    selectPerUnitType,
    (productsKeyedById, entitySummaries, productId, perUnitType): string => {
        const unitsPerArea = get(productsKeyedById, [
            productId,
            'unitsPerArea'
        ]);

        // Still return a valid number even if there are some nulls
        const sumUnits = entitySummaries.reduce((previous, current) => {
            const units =
                perUnitType === HECTARE
                    ? current.sumTotalArea
                    : current.sumNumberOfTrees;
            return previous + (units || 0);
        }, 0);

        if (perUnitType === HECTARE) {
            return Number(unitsPerArea * sumUnits).toFixed(2);
        }
        return Number(unitsPerArea * sumUnits).toString();
    }
);

const makeSelectProductTotal = (): typeof selectProductTotal =>
    selectProductTotal;

const selectProductUnitType = createDeepEqualSelector(
    selectFertilizerWorksheetProductsKeyedById,
    selectProductId,
    (productsKeyedById, productId) =>
        get(productsKeyedById, [
            productId,
            'fertilizerProduct',
            'unitType',
            'name'
        ])
);

const makeSelectProductUnitType = (): typeof selectProductUnitType =>
    selectProductUnitType;

export { selectProductId, makeSelectProductTotal, makeSelectProductUnitType };
